var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home-banner',{attrs:{"title":_vm.bannerTitle}}),_c('home-ramp',{attrs:{"title":_vm.ramp.title,"description":_vm.ramp.description}}),_c('home-slogan'),_c('home-who',{attrs:{"title":_vm.who.title,"description":_vm.who.description}}),_c('home-brands'),_c('home-join')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }